const isDevelopment = () => process.env.NODE_ENV === 'development';
const host = window.location.hostname;

const isProduction = () => {
  if(process.env.NODE_ENV === 'production' && host.includes('kkt-neva')) {
    return true;
  }
  return false;
}

const isTest = () => {
  if(process.env.NODE_ENV === 'production' && !host.includes('kkt-neva')) {
    return true;
  }
  return false;
};

export { isDevelopment, isProduction, isTest };